import type {RouteRecordRaw} from 'vue-router';
import {SystemMessageType} from '@myparcel-frontend/types';

export const casesRoutes: RouteRecordRaw[] = [
  {
    name: 'contact',
    path: '/contact',
    component: () => import('@/views/Contact/Contact.vue'),
    meta: {
      permissions: ['ticketCreate'],
      title: (t) => t('support.contact.title'),
      systemMessageType: SystemMessageType.CONTACT,
    },
  },
  {
    path: '/cases',
    meta: {
      permissions: ['selectSupportCase'],
    },
    children: [
      {
        name: 'cases-index',
        path: '',
        component: () => import('@/views/SupportCases/SupportCaseOverview/SupportCaseOverview.vue'),
        meta: {
          systemMessageType: SystemMessageType.CASES_OVERVIEW,
        },
      },
      {
        name: 'cases-detail',
        path: ':id',
        props: true,
        component: () => import('@/views/SupportCases/SupportCaseDetail.vue'),
        meta: {
          permissions: ['selectSupportCase'],
          title: (t) => t('support.contact.caseSummary'),
        },
      },
    ],
  },
];
